/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Challenge_Active_Days_HintInputs */

const en_us2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each day with at least one workout finished in the app counts.`)
};

const pt_br2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada dia com pelo menos um treino concluído no app conta.`)
};

const es_419_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta cada día con al menos un entrenamiento terminado en la app.`)
};

const pt_pt2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta cada dia com pelo menos um treino concluído na app.`)
};

const fr_fr2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque jour avec au moins une séance terminée dans l'appli compte.`)
};

const de_de2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Tag mit mindestens einem in der App beendeten Training zählt.`)
};

const it_it2_clubs_challenge_active_days_hint = /** @type {(inputs: Clubs_Challenge_Active_Days_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta ogni giorno con almeno un allenamento concluso nell'app.`)
};

/**
* | output |
* | --- |
* | "Each day with at least one workout finished in the app counts." |
*
* @param {Clubs_Challenge_Active_Days_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_challenge_active_days_hint = /** @type {((inputs?: Clubs_Challenge_Active_Days_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Challenge_Active_Days_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_challenge_active_days_hint(inputs)
	if (locale === "es-419") return es_419_clubs_challenge_active_days_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_challenge_active_days_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_challenge_active_days_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_challenge_active_days_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_challenge_active_days_hint(inputs)
	return en_us2_clubs_challenge_active_days_hint(inputs)
});
export { clubs_challenge_active_days_hint as "clubs.challenge_active_days_hint" }